<template>
  <main-container class="account-container" title="アカウント情報" :showFooter="false">
    <div slot="main-content">
      <div>
        <h2 class="title">ログイン情報</h2>
        <table>
          <tr>
            <th>ユーザーID</th>
            <td>{{userId}}</td>
          </tr>
          <tr>
            <th>パスワード
              <el-button type="primary" size="mini" style="margin-left: 6px;" @click="visiblePasswordChange=true">変更
              </el-button>
            </th>
            <td>**********<br>※パスワードをお忘れの際は、サポートまでご連絡ください</td>
            <password-change v-if="visiblePasswordChange" @close="visiblePasswordChange=false"></password-change>
          </tr>
        </table>

        <h2 class="title">契約情報</h2>
        <table>
          <tr>
            <th>契約プラン</th>
            <td>{{account ? account.plan.planName : ''}}</td>
          </tr>
          <tr>
            <th>アカウント開設日</th>
            <td>{{account ? account.customer.created : ''}}</td>
          </tr>
          <tr>
            <th>契約開始日</th>
            <td>{{account ? account.customer.contract.start : ''}}</td>
          </tr>
          <tr>
            <th>契約終了日</th>
            <td>{{account ? account.customer.contract.end : ''}}</td>
          </tr>
          <tr>
            <th>APIキー</th>
            <td>{{account ? account.customer.apiKey : ''}}</td>
          </tr>
          <tr>
            <th>APIシークレット</th>
            <td>{{account ? account.customer.apiSecret : ''}}</td>
          </tr>
        </table>

        <h2 class="title">ご利用状況（合計）</h2>
        <table>
          <tr>
            <th>モデル数</th>
            <td>
              <template v-if="account">{{account.availability.model | number_format}}モデル</template>
            </td>
          </tr>
          <tr>
            <th>適用件数</th>
            <td>
              <template v-if="account">{{account.availability.appliedData | number_format}}件</template>
            </td>
          </tr>
        </table>

        <h2 id="billing_this_month" class="title">今月課金対象</h2>
        <table>
          <tr>
            <th>モデル数
              <tooltip-icon content="モデル作成から3日以上経過したモデルが課金対象となります。\n今月1日時点で削除済みのモデルは課金の対象外となります。"></tooltip-icon>
            </th>
            <td>
              <template v-if="account && account.plan.overStoredModelBilling === 0">
                <span>無制限</span>
              </template>
              <template v-else-if="account">
                <span v-if="account.billing.model <= account.plan.storageModelLimit">{{account.billing.model}}</span>
                <span v-else><strong>{{account.billing.model | number_format}}</strong></span>
                <span> / {{account.plan.storageModelLimit | number_format}}モデル</span>
                <br><span>超過料金 {{account.plan.overStoredModelBilling | number_format}}円/モデル</span>
              </template>
            </td>
          </tr>
          <tr>
            <th>適用件数
              <tooltip-icon content="今月モデルを適用した件数が課金対象となります。"></tooltip-icon>
            </th>
            <td>
              <template v-if="account && account.plan.overAppliedDataBilling === 0">
                <span>無制限</span>
              </template>
              <template v-else-if="account">
                <span v-if="account.billing.appliedData <= account.plan.appliedDataLimit">{{account.billing.appliedData | number_format}}</span>
                <span v-else><strong>{{account.billing.appliedData | number_format}}</strong></span>
                <span> / {{account.plan.appliedDataLimit | number_format}}件</span>
                <br><span>超過料金 {{account.plan.overAppliedDataBilling | number_format}}円/件 (1円未満は切り捨て)</span>
              </template>
            </td>
          </tr>
        </table>

        <h2 class="title">ご利用の累積</h2>
        <table>
          <tr>
            <th>モデル数</th>
            <td>
              <template v-if="account">{{account.cumulation.model | number_format}}モデル</template>
            </td>
          </tr>
          <tr>
            <th>適用件数</th>
            <td>
              <template v-if="account">{{account.cumulation.appliedData | number_format}}件</template>
            </td>
          </tr>
        </table>
      </div>

      <div class="support-container">
        <div class="support">
          <h2>サポート</h2>
          <p class="mail">support-skyfox@sxi.co.jp</p>
          <p>サービス時間：平日 10:00～18:00</p>
        </div>

        <div class="terms">
          <h2>利用規約</h2>
          <el-button type="info" @click="onClickTerms" style="width: 230px; height: 60px;">利用規約を確認する</el-button>
        </div>
      </div>
    </div>
  </main-container>
</template>

<script lang="js">
import BaseView from '../base'
import PasswordChangeDialogCmp from '../../components/account/dialogs/password-change.vue'
import WebApiClient from '../../api/web'

export default {
  name: 'AccountView',
  mixins: [BaseView],
  components: {
    'password-change': PasswordChangeDialogCmp
  },
  props: {},
  data () {
    return {
      userId: '',
      account: null,
      visiblePasswordChange: false
    }
  },
  created () {
    this.userId = this.$session.get('USER_ID')
    WebApiClient.getAccount(this, this.userId).then((response) => {
      this.account = response.data.result
    })
  },

  mounted () {
    this.scrollToAnchor()
  },
  methods: {
    onClickTerms () {
      window.open('https://skyfox.ai/terms_of_service.pdf')
    }
  }
}

</script>

<style scoped>
  .account-container >>> .main-content > div > div:first-child {
    padding: 24px;
    max-width: 1000px;
  }

  .account-container .title {
    font-size: 1.5rem;
    font-weight: normal;
    padding: 50px 0 0 0;
  }

  .account-container .title:first-child {
    padding: 0;
  }

  .account-container table {
    border-spacing: 0;
  }

  .account-container table th {
    min-width: 220px;
    max-width: 220px;
    background: #e3ebf4;
    text-align: left;
  }

  .account-container table td {
    width: 800px;
    background: #fff;
  }

  .account-container table th,
  .account-container table td {
    padding: 16px 20px;
    border: 1px solid #c0d5ef;
    font-size: 0.88rem;
  }

  .account-container table td {
    border-left: none;
  }

  .account-container table tr:not(:first-child) th,
  .account-container table tr:not(:first-child) td {
    border-top: none;
  }

  .support-container {
    display: flex;
    justify-content: center;
    flex-shrink: 0;
    padding: 24px 40px;
    background: #f1f5f8;
  }

  .support-container .support {
    width: 380px;
  }

  .support-container h2 {
    font-size: 1.5rem;
    font-weight: normal;
    margin: 0 0 16px 0;
  }

  strong {
    color: #d8243e;
  }

  .mail {
    font-size: 1.5rem;
    font-weight: bold;
    background: url(../../../static/img/mail.png) no-repeat left center;
    background-size: 26px 18px;
    padding: 0 0 0 40px;
    line-height: 1;
    margin: 0 0 16px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/account.vue